(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function findScrollContainer(bar) {
      var section = bar.closest('.section-resource-list');
      if (!section) return null;

      // Horizon's carousel scroller is het <slideshow-slides ref="scroller"> element,
      // gerenderd door snippets/slideshow.liquid. Dit is het element dat daadwerkelijk
      // horizontaal scrolt (scroll-snap), niet de .resource-list wrapper eromheen.
      var scroller = section.querySelector('slideshow-slides[ref="scroller"]')
        || section.querySelector('slideshow-slides');

      if (scroller) return scroller;

      // Fallback: zoek het eerste horizontaal scrollbare element binnen de sectie
      var all = section.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.scrollWidth > el.clientWidth + 2) {
          var overflowX = getComputedStyle(el).overflowX;
          if (overflowX === 'auto' || overflowX === 'scroll') return el;
        }
      }
      return null;
    }

    function initBar(bar) {
      if (bar.dataset.scrollbarReady) return;

      var scrollContainer = findScrollContainer(bar);
      if (!scrollContainer) return;

      bar.dataset.scrollbarReady = 'true';

      var track = bar.querySelector('[data-scrollbar-track]');
      var thumb = bar.querySelector('[data-scrollbar-thumb]');

      function update() {
        var scrollable = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        var isScrollable = scrollable > 4;
        bar.dataset.visible = isScrollable ? 'true' : 'false';
        if (!isScrollable) return;

        var visibleRatio = scrollContainer.clientWidth / scrollContainer.scrollWidth;
        var thumbWidth = Math.max(visibleRatio * track.clientWidth, 32);
        var maxThumbLeft = track.clientWidth - thumbWidth;
        var progress = scrollContainer.scrollLeft / scrollable;

        thumb.style.width = thumbWidth + 'px';
        thumb.style.left = (progress * maxThumbLeft) + 'px';
      }

      scrollContainer.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();

      // Slepen aan de balk om te scrollen
      var isDragging = false;
      var dragStartX = 0;
      var scrollStartLeft = 0;

      thumb.addEventListener('pointerdown', function (e) {
        isDragging = true;
        dragStartX = e.clientX;
        scrollStartLeft = scrollContainer.scrollLeft;
        thumb.setPointerCapture(e.pointerId);
      });

      thumb.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        var scrollable = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        var maxThumbLeft = track.clientWidth - thumb.clientWidth;
        var deltaX = e.clientX - dragStartX;
        var deltaScroll = maxThumbLeft > 0 ? (deltaX / maxThumbLeft) * scrollable : 0;
        scrollContainer.scrollLeft = scrollStartLeft + deltaScroll;
      });

      ['pointerup', 'pointercancel'].forEach(function (evt) {
        thumb.addEventListener(evt, function () {
          isDragging = false;
        });
      });

      // Klik op de track om direct te springen
      track.addEventListener('click', function (e) {
        if (e.target === thumb) return;
        var rect = track.getBoundingClientRect();
        var clickRatio = (e.clientX - rect.left) / rect.width;
        var scrollable = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        scrollContainer.scrollLeft = clickRatio * scrollable;
      });
    }

    function removeFullWidthBreakout(root) {
      (root || document)
        .querySelectorAll('.section-resource-list .resource-list.force-full-width')
        .forEach(function (el) {
          el.classList.remove('force-full-width');
          el.style.gridColumn = '2';
        });
    }

    function initAll(root) {
      removeFullWidthBreakout(root);
      (root || document).querySelectorAll('[data-product-list-scrollbar]').forEach(initBar);
    }

    // Zo vroeg mogelijk uitvoeren om een flits van de volle breedte te voorkomen
    removeFullWidthBreakout(document);

    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      // Korte retries voor het geval het carousel-element iets later in de DOM verschijnt
      [100, 300, 800].forEach(function (delay) {
        setTimeout(function () {
          initAll(document);
        }, delay);
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function findScrollContainer(bar) {
      var section = bar.closest('.section-resource-list');
      if (!section) return null;

      // Horizon's carousel scroller is het <slideshow-slides ref="scroller"> element,
      // gerenderd door snippets/slideshow.liquid. Dit is het element dat daadwerkelijk
      // horizontaal scrolt (scroll-snap), niet de .resource-list wrapper eromheen.
      var scroller = section.querySelector('slideshow-slides[ref="scroller"]')
        || section.querySelector('slideshow-slides');

      if (scroller) return scroller;

      // Fallback: zoek het eerste horizontaal scrollbare element binnen de sectie
      var all = section.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.scrollWidth > el.clientWidth + 2) {
          var overflowX = getComputedStyle(el).overflowX;
          if (overflowX === 'auto' || overflowX === 'scroll') return el;
        }
      }
      return null;
    }

    function initBar(bar) {
      if (bar.dataset.scrollbarReady) return;

      var scrollContainer = findScrollContainer(bar);
      if (!scrollContainer) return;

      bar.dataset.scrollbarReady = 'true';

      var track = bar.querySelector('[data-scrollbar-track]');
      var thumb = bar.querySelector('[data-scrollbar-thumb]');

      function update() {
        var scrollable = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        var isScrollable = scrollable > 4;
        bar.dataset.visible = isScrollable ? 'true' : 'false';
        if (!isScrollable) return;

        var visibleRatio = scrollContainer.clientWidth / scrollContainer.scrollWidth;
        var thumbWidth = Math.max(visibleRatio * track.clientWidth, 32);
        var maxThumbLeft = track.clientWidth - thumbWidth;
        var progress = scrollContainer.scrollLeft / scrollable;

        thumb.style.width = thumbWidth + 'px';
        thumb.style.left = (progress * maxThumbLeft) + 'px';
      }

      scrollContainer.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();

      // Slepen aan de balk om te scrollen
      var isDragging = false;
      var dragStartX = 0;
      var scrollStartLeft = 0;

      thumb.addEventListener('pointerdown', function (e) {
        isDragging = true;
        dragStartX = e.clientX;
        scrollStartLeft = scrollContainer.scrollLeft;
        thumb.setPointerCapture(e.pointerId);
      });

      thumb.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        var scrollable = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        var maxThumbLeft = track.clientWidth - thumb.clientWidth;
        var deltaX = e.clientX - dragStartX;
        var deltaScroll = maxThumbLeft > 0 ? (deltaX / maxThumbLeft) * scrollable : 0;
        scrollContainer.scrollLeft = scrollStartLeft + deltaScroll;
      });

      ['pointerup', 'pointercancel'].forEach(function (evt) {
        thumb.addEventListener(evt, function () {
          isDragging = false;
        });
      });

      // Klik op de track om direct te springen
      track.addEventListener('click', function (e) {
        if (e.target === thumb) return;
        var rect = track.getBoundingClientRect();
        var clickRatio = (e.clientX - rect.left) / rect.width;
        var scrollable = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        scrollContainer.scrollLeft = clickRatio * scrollable;
      });
    }

    function removeFullWidthBreakout(root) {
      (root || document)
        .querySelectorAll('.section-resource-list .resource-list.force-full-width')
        .forEach(function (el) {
          el.classList.remove('force-full-width');
          el.style.gridColumn = '2';
        });
    }

    function initAll(root) {
      removeFullWidthBreakout(root);
      (root || document).querySelectorAll('[data-product-list-scrollbar]').forEach(initBar);
    }

    // Zo vroeg mogelijk uitvoeren om een flits van de volle breedte te voorkomen
    removeFullWidthBreakout(document);

    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      // Korte retries voor het geval het carousel-element iets later in de DOM verschijnt
      // (deze sectie laadt producten async via fetch, dus het duurt iets langer)
      [100, 300, 800, 1500].forEach(function (delay) {
        setTimeout(function () {
          initAll(document);
        }, delay);
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    // Deze sectie herbouwt zijn inhoud async zodra de aanbevelingen binnenkomen
    // (via <product-recommendations>), dus we volgen ook DOM-mutaties.
    var observer = new MutationObserver(function () {
      initAll(document);
    });
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('product-recommendations').forEach(function (el) {
        observer.observe(el, { childList: true, subtree: true });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
